module.exports = __webpack_public_path__ + "static/media/checkmark.cb57ce9b.png";